import PropTypes from "prop-types";
import React, { Component } from "react";

import classNames from "classnames";
import onClickOutside from "react-onclickoutside";

import { Overlay } from "react-overlays";
import { MdExpandLess } from "@react-icons/all-files/md/MdExpandLess";
import { MdExpandMore } from "@react-icons/all-files/md/MdExpandMore";

import Item from "./Item";

import "./_style.scss";

class Select extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
  };

  static defaultProps = {
    onItemDeselect: () => {},
    onItemSelect: () => {},
    selectedItems: [],
    showAllItem: { label: "All", value: "all" },
    allowMultiSelect: false,
  };

  state = {
    isOpen: false,
  };

  UNSAFE_componentWillMount() {
    // fixes an issue for outside-touch on ios
    // details: https://github.com/kentor/react-click-outside/issues/4
    if ("ontouchstart" in document.documentElement) {
      document.body.style.cursor = "pointer";
    }
  }

  // used by onClickOutside
  // eslint-disable-next-line react/no-unused-class-component-methods
  handleClickOutside = () => {
    this.setState({
      isOpen: false,
    });
  };

  toggleOpenClose = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  itemIsSelected = (item) => {
    const {
      selectedItems = [],
      onClose = () => {
      },
    } = this.props;
    onClose();
    return !!~selectedItems.indexOf(item);
  };

  render() {
    const {
      allowMultiSelect,
      className,
      items,
      name,
      onItemDeselect,
      onItemSelect,
      onSelectAll,
      overlayContainer,
      selectedItems,
      showAllItem,
    } = this.props;

    const {
      isOpen,
    } = this.state;

    const hasNoItemsSelected = !!selectedItems.length;
    const itemsToDisplay = hasNoItemsSelected ? selectedItems : [showAllItem];

    const getClickHandler = (item) => {
      if (item === showAllItem) {
        return () => {};
      }
      // close on click if we don't allow multiselect
      if (!allowMultiSelect) {
        this.toggleOpenClose();
      }

      return this.itemIsSelected(item) ? onItemDeselect(item) : onItemSelect(item);
    };

    return (
      <div
        className={classNames(
          "Select",
          className,
          { "--isOpen": isOpen },
        )}
        ref="wrapper"
      >
        <div
          className={
            classNames(
              "Select__input",
              {
                "--isOpen": isOpen,
              },
            )
          }
          onClick={this.toggleOpenClose}
          ref={name}
        >
          <div className="Select__selectedItems">
            {itemsToDisplay.map((item, i) => (
              <span
                key={i}
                className="Select__selectedItem"
              >
                {item.label}
                {i + 1 < itemsToDisplay.length ? "," : ""}
              </span>
            ))}
          </div>
          <div className="Select__stateIndicator">
            {
              isOpen
                ? <MdExpandLess size="20px" color="#1fa8df" />
                : <MdExpandMore size="20px" />
            }
          </div>
        </div>
        <Overlay
          show={isOpen}
          container={overlayContainer || this}
          placement="bottom"
          target={() => this.refs[name]}
          shouldUpdatePosition
        >
          <div className="ignore-react-onclickoutside" style={{ position: "absolute", zIndex: 400 }}>
            <ul className="Select__items">
              <li
                key={0}
              >
                <Item
                  key={0}
                  item={showAllItem}
                  doShowClear={false}
                  doShowAddIcon={false}
                  onClick={() => {
                    if (!allowMultiSelect) {
                      this.toggleOpenClose();
                    }
                    onSelectAll();
                  }}
                />
              </li>
              {items.map((item, i) => (
                <li
                  key={i + 1}
                  className={
                    classNames("Select__item", {
                      "--selected": this.itemIsSelected(item),
                    })
                  }
                >
                  <Item
                    key={i}
                    item={item}
                    isSelected={this.itemIsSelected(item)}
                    onClick={() => getClickHandler(item)}
                    doShowAddIcon={allowMultiSelect}
                  />
                </li>
              ))}
            </ul>
          </div>
        </Overlay>
      </div>
    );
  }
}

export default onClickOutside(Select);
